import { getPrefix } from './initExport';

function normalizeLang(code) {
  const allow = new Set(['ko', 'en', 'zh-CN', 'ja']);
  return allow.has(code) ? code : 'ko';
}

export function initGlobe() {
  const PREFIX = getPrefix();
  const LANG_KEY = `${PREFIX}prefs:lang`;
  const LEGACY_KEY = 'site_lang';

  return {
    open: false,
    current: 'ko',

    items: [
      { code: 'ko', label: 'KO' },
      { code: 'en', label: 'EN' },
      { code: 'zh-CN', label: 'CN' },
      { code: 'ja', label: 'JP' },
    ],

    init() {
      // 1) 새 키 우선
      const saved = localStorage.getItem(LANG_KEY);

      // 2) 없으면 레거시에서 마이그레이션
      if (saved) {
        this.current = normalizeLang(saved);
      } else {
        const legacy = localStorage.getItem(LEGACY_KEY);
        if (legacy) {
          this.current = normalizeLang(legacy);
          localStorage.setItem(LANG_KEY, this.current);
          localStorage.removeItem(LEGACY_KEY);
        }
      }

      // init에서는 reload 금지. 대신 쿠키만 current와 동기화
      this.setSiteLangCookie(this.current);

      if (this.current === 'ko') {
        this.clearGoogtransCookie();
      } else {
        this.applyGoogtransCookie(this.current);
      }

      this.loadGoogleTranslate();
    },

    setLang(code) {
      code = normalizeLang(code);

      if (code === this.current) {
        this.open = false;
        return;
      }

      this.current = code;

      // ✅ 통일 키로 저장
      localStorage.setItem(LANG_KEY, code);
      // 레거시 제거(선택)
      localStorage.removeItem(LEGACY_KEY);

      this.setSiteLangCookie(code);

      // ✅ 쿠키만 설정 후 reload는 딱 1번만
      if (code === 'ko') {
        this.clearGoogtransCookie();
      } else {
        this.applyGoogtransCookie(code);
      }

      this.open = false;
      window.location.reload();
    },

    // => 쿠키 세팅만 하는 함수로 변경
    applyGoogtransCookie(code) {
      const source = 'ko';
      const target = code === 'ko' ? 'ko' : code;
      const value = `/${source}/${target}`;
      const host = location.hostname;

      document.cookie = `googtrans=${value}; path=/; max-age=31536000`;

      if (host !== 'localhost' && !/^\d+\.\d+\.\d+\.\d+$/.test(host)) {
        document.cookie = `googtrans=${value}; path=/; domain=${host}; max-age=31536000`;

        const rootDomain = host.endsWith('.co.kr')
          ? '.' + host.split('.').slice(-3).join('.')
          : '.' + host.split('.').slice(-2).join('.');

        document.cookie = `googtrans=${value}; path=/; domain=${rootDomain}; max-age=31536000`;
      }
    },

    clearGoogtransCookie() {
      const host = location.hostname;
      const expired =
        'googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';

      document.cookie = expired;

      if (host !== 'localhost' && !/^\d+\.\d+\.\d+\.\d+$/.test(host)) {
        document.cookie = `${expired}; domain=${host}`;

        const rootDomain = host.endsWith('.co.kr')
          ? '.' + host.split('.').slice(-3).join('.')
          : '.' + host.split('.').slice(-2).join('.');

        document.cookie = `${expired}; domain=${rootDomain}`;
      }
    },

    setSiteLangCookie(code) {
      const host = location.hostname;
      const value = `site_lang=${code}; path=/; max-age=31536000`;

      document.cookie = value;

      if (host !== 'localhost' && !/^\d+\.\d+\.\d+\.\d+$/.test(host)) {
        document.cookie = `${value}; domain=${host}`;

        const rootDomain = host.endsWith('.co.kr')
          ? '.' + host.split('.').slice(-3).join('.')
          : '.' + host.split('.').slice(-2).join('.');

        document.cookie = `${value}; domain=${rootDomain}`;
      }
    },

    loadGoogleTranslate() {
      if (window.google && window.google.translate) return;

      if (!window.__gtInit) {
        window.__gtInit = () => {
          new window.google.translate.TranslateElement(
            { pageLanguage: 'ko', autoDisplay: false },
            'google_translate_element'
          );
        };
      }

      if (!document.querySelector('script[data-gt="1"]')) {
        const s = document.createElement('script');
        s.src = '//translate.google.com/translate_a/element.js?cb=__gtInit';
        s.async = true;
        s.dataset.gt = '1';
        document.head.appendChild(s);
      }
    },
  };
}
